import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { withRouter } from '~HOC';
import NotFound from './notFound/notFound';
import PrivateRoute from './PrivateRoute';
import ProfileLayout from '../layout/profileLayout';
import AuthorizeLayout from '../layout/authorizeLayout';
import GeneralLayout from '../layout/generalLayout';
import * as userActions from '../actions/user';
import { connect } from 'react-redux';
import { Spinner } from '../component';
// Services
import '../content/styles/fonts.css';
import ProtectedRoute from './ProtectedRoute';
import Gateway from './profile/gateway';
//--------------------------Profile Route------------------------------

//#region ProfilesRoute
const Dashboard = lazy(() => import('./profile/dashboard/dashboard'));
const UserBasicInfo = lazy(() => import('./profile/profile/userBasicInfo'));
const EditBusinessProfilePage = lazy(() =>
  import('./profile/profile/bussinessProfileInfo/bussienssProfileInfo'),
);
const SendVerificationSms = lazy(() =>
  import('./profile/sendVerificationSms/SendVerificationSms'),
);

const VerificationCheck = lazy(() =>
  import('./profile/verificationCheck/verificationCheck'),
);

const CompleteProfile = lazy(() =>
  import('./profile/completeProfile/completeProfile'),
);

const EmployeeManagement = lazy(() =>
  import('./profile/employeeManagement/employeeManagement'),
);
const AirlineQuota = lazy(() => import('./profile/airLineQuota/airlineQuota'));

const InvoicePayment = lazy(() =>
  import('./profile/financialManagement/invoiceCallBack'),
);
const TicketComponent = lazy(() => import('./profile/ticket/ticket'));
const BusinessProfile = lazy(() => import('./profile/profile/businessProfile'));
const ProfileSigniture = lazy(() =>
  import('./profile/profileSigniture/profileSigniture'),
);
const SelectProfileType = lazy(() =>
  import('./profile/profile/selectPofileType'),
);
const SendProfileForVerification = lazy(() =>
  import('./profile/profile/sendProfileForVerification'),
);
const BookingFlights = lazy(() =>
  import('./profile/profile/bookingFlights/bookingFlights'),
);
const FinancialManagement = lazy(() =>
  import('./profile/financialManagement/financialManagement'),
);
const UserPoint = lazy(() => import('./profile/profile/userPoint'));
const ProfileDepartment = lazy(() =>
  import('./profile/profileDepartments/profileDepartments'),
);
const ProfileSaleAccounting = lazy(() =>
  import('./profile/profile/profileSaleAccounting'),
);
const CommissionManagement = lazy(() =>
  import('./profile/commissionManagement/commissionManagement'),
);
const ProfileCreditReport = lazy(() =>
  import('./profile/profile/profileCreditReport'),
);
const CustomerManagement = lazy(() =>
  import('./profile/customerManagement/customerManagement'),
);
const ChargeWallet = lazy(() => import('./profile/wallet/wallet-charge'));
const PaymentResult = lazy(() => import('./profile/wallet/paymentResult'));

const EmployeeCreditAllocation = lazy(() =>
  import('./profile/employeeCreditAllocation/employeeCreditAllocation'),
);
const MyCredit = lazy(() => import('./profile/myCredit/myCredit'));
const TourManagement = lazy(() =>
  import('./profile/tourManagement/tourManagement'),
);
//#endregion
//--------------------------Booking Route------------------------------
//#region  Booking
const SelectCity = lazy(() => import('./flight-booking/selectCity/selectCity'));
const SelectFlights = lazy(() =>
  import('./flight-booking/selectFlights/selectFlights'),
);
const SelectLoginType = lazy(() =>
  import('./flight-booking/selectLoginType/selectLoginType'),
);
const Identify = lazy(() => import('./flight-booking/identify/identify'));

const FlightInvoice = lazy(() =>
  import('./flight-booking/flightInvoice/flightInvoice'),
);
const FlightTicket = lazy(() =>
  import('./flight-booking/flightTicket/flightTicket'),
);

const TicketPaymentResult = lazy(() =>
  import('./flight-booking/flightTicket/paymentResult'),
);
const PrintFlightTicket = lazy(() =>
  import('../component/specific/booking/printFlightTicket'),
);
const TrackingOrder = lazy(() =>
  import('./flight-booking/trackingOrder/trackingOrder'),
);
const TourDetail = lazy(() => import('./flight-booking/tourdetail/tourDetail'));
//#endregion
//--------------------------General Route------------------------------
//#region General
const About = lazy(() => import('./../domain/about/about'));
const Claim = lazy(() => import('./../domain/claim/claim'));
const ContactUsForm = lazy(() => import('./contactUsForm/contactUsForm'));
const AboutTripsi = lazy(() => import('./about/aboutTripsi'));
const Rules = lazy(() => import('./profile/profile/cancelRules/rules'));
const Privacy = lazy(() => import('./flight-booking/privacy/privacy'));

//#endregion

//--------------------------Authentication Route------------------------------
//#region  Authentications
const Login = lazy(() => import('./authentication/login/login'));
const OtpLogin = lazy(() => import('./authentication/otpLogin/otpLogin'));
const SignUp = lazy(() => import('./authentication/signup/signup'));
const ResetPassword = lazy(() =>
  import('./authentication/resetPassword/resetPassword'),
);
const ForgetPassword = lazy(() =>
  import('./authentication/forgetPassword/forgetPassword'),
);
const SendPasswordSuccessfully = lazy(() =>
  import('./authentication/sendPasswordSuccessfully/sendPasswordSuccessfully'),
);
const OtherOption = lazy(() => import('./otherOption/otherOption'));
const PaymentTestPage = lazy(() =>
  import('./flight-booking/Payment-new/PaymentSection/testPayment'),
);

//#endregion

class NewRoutes extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Routes>
        <Route path="/" element={<GeneralLayout />}>
          <Route path={''} Component={() => <SelectCity {...this.props} />} />
        </Route>
        {/* ----------------------------- profileRoutes------------------------------ */}
        <Route path="/profile/*" element={<ProfileLayout />}>
          <Route
            path="dashboard"
            element={
              <PrivateRoute loading={<Spinner />}>
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="user-basic-info"
            element={
              <PrivateRoute loading={<Spinner />}>
                <UserBasicInfo {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="edit-business-profile"
            element={
              <PrivateRoute loading={<Spinner />}>
                <EditBusinessProfilePage satuation="update" {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="send-verification-sms"
            element={
              <PrivateRoute loading={<Spinner />}>
                <SendVerificationSms {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="verification-check"
            element={
              <PrivateRoute loading={<Spinner />}>
                <VerificationCheck {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="complete-profile"
            element={
              <PrivateRoute loading={<Spinner />}>
                <CompleteProfile {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="ticket"
            element={
              <PrivateRoute loading={<Spinner />}>
                <TicketComponent {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="employee-management"
            element={
              <ProtectedRoute>
                <PrivateRoute loading={<Spinner />}>
                  <EmployeeManagement {...this.props} />
                </PrivateRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="commission-management"
            element={
              <PrivateRoute loading={<Spinner />}>
                <CommissionManagement {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="airline-quota"
            element={
              <PrivateRoute loading={<Spinner />}>
                <AirlineQuota {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="business-profile"
            element={
              <ProtectedRoute>
                <PrivateRoute loading={<Spinner />}>
                  <BusinessProfile {...this.props} />
                </PrivateRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="profile-signiture"
            element={
              <PrivateRoute loading={<Spinner />}>
                <ProfileSigniture {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="select-profile-type"
            element={
              <PrivateRoute loading={<Spinner />}>
                <SelectProfileType {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="send-profile-for-verification"
            element={
              <PrivateRoute loading={<Spinner />}>
                <SendProfileForVerification {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="booking-flights"
            element={
              <PrivateRoute loading={<Spinner />}>
                <BookingFlights {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="financial-management"
            element={
              <PrivateRoute loading={<Spinner />}>
                <FinancialManagement {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="user-point"
            element={
              <PrivateRoute loading={<Spinner />}>
                <UserPoint {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="profile-department"
            element={
              <PrivateRoute loading={<Spinner />}>
                <ProfileDepartment {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="profile-accounts"
            element={
              <PrivateRoute loading={<Spinner />}>
                <ProfileSaleAccounting {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="customer-managment"
            element={
              <ProtectedRoute>
                <PrivateRoute loading={<Spinner />}>
                  <CustomerManagement {...this.props} />
                </PrivateRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="my-credit"
            element={
              <PrivateRoute loading={<Spinner />}>
                <MyCredit {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="charge-wallet"
            element={
              <PrivateRoute loading={<Spinner />}>
                <ChargeWallet {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="profile-credit-report"
            element={
              <PrivateRoute loading={<Spinner />}>
                <ProfileCreditReport {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="employee-credit-allocation"
            element={
              <PrivateRoute loading={<Spinner />}>
                <EmployeeCreditAllocation {...this.props} />
              </PrivateRoute>
            }
          />
          <Route
            path="tour-management"
            element={
              <ProtectedRoute>
                <PrivateRoute loading={<Spinner />}>
                  <TourManagement {...this.props} />
                </PrivateRoute>
              </ProtectedRoute>
            }
          />
          <Route
            path="gateway"
            element={
              <PrivateRoute loading={<Spinner />}>
                <Gateway />
              </PrivateRoute>
            }
          />
        </Route>
        {/* ---------------------------bookingRoute------------------------- */}
        <Route path="/booking/*" element={<GeneralLayout />}>
          <Route
            path={'select-city'}
            Component={() => <SelectCity {...this.props} />}
          />
          <Route
            path="select-flight"
            Component={() => <SelectFlights {...this.props} />}
          />
          <Route
            path="select-login-type"
            Component={() => <SelectLoginType {...this.props} />}
          />
          <Route
            path="identify"
            Component={() => <Identify {...this.props} />}
          />
          <Route
            path="flight-invoice"
            Component={() => <FlightInvoice {...this.props} />}
          />
          <Route
            path="flight-ticket"
            Component={() => <FlightTicket {...this.props} />}
          />
          <Route
            path="print-flight-ticket"
            Component={() => <PrintFlightTicket {...this.props} />}
          />
          <Route
            path="payment-result"
            Component={() => <TicketPaymentResult {...this.props} />}
          />

          <Route
            path="tracking-order"
            Component={() => <TrackingOrder {...this.props} />}
          />
        </Route>
        {/* ---------------------------Authentication------------------------- */}
        <Route path="" element={<AuthorizeLayout />}>
          <Route path="/login" Component={() => <Login />} />
          <Route
            path="/otp-login"
            Component={() => <OtpLogin {...this.props} />}
          />
          <Route path="/signup" Component={() => <SignUp {...this.props} />} />
          <Route
            path="/reset-password"
            Component={() => <ResetPassword {...this.props} />}
          />
          <Route
            path="/forget-password"
            Component={() => <ForgetPassword {...this.props} />}
          />
          <Route
            path="/send-password-successfully"
            Component={() => <SendPasswordSuccessfully {...this.props} />}
          />
          <Route
            path="/payment-result"
            Component={() => <PaymentResult {...this.props} />}
          />
        </Route>
        <Route path="" element={<GeneralLayout />}>
          {/* ---------------------------Generals------------------------- */}
          <Route path="/about" Component={() => <AboutTripsi />} />
          <Route path="/claim" Component={() => <Claim />} />
          <Route path="/rules" Component={() => <Rules />} />
          <Route path="/privacy" Component={() => <Privacy />} />
          <Route path="/other-option" Component={() => <OtherOption />} />
          <Route path="*" Component={() => <NotFound />} />
          <Route path="tour-detail" Component={() => <TourDetail />} />
          <Route
            path="invoice-payment"
            Component={() => <InvoicePayment {...this.props} />}
          />
        </Route>
        <Route path="/test/" element={<GeneralLayout />}>
          <Route path="payment" Component={() => <PaymentTestPage />} />
        </Route>
      </Routes>
    );
  }
}
const mapStateToProps = (state) => {
  const { name: language, direction } = state.language;
  let user = state?.user?.userInfo;
  return { language, direction, user };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateUser: (user) => dispatch(userActions.updateUser(user)),
    clearUser: () => dispatch(userActions.clearUser()),
    changeLanguage: (lang) => dispatch(languageActions.changeLanguage(lang)),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NewRoutes),
);
